import React from "react";
import { reportError } from "../../lib/errorReporting";

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends React.Component<
  React.PropsWithChildren,
  State
> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    void reportError(error, {
      operation: "react.render",
      severity: "fatal",
      metadata: { componentStack: info.componentStack },
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <main style={{ padding: "2rem", textAlign: "center" }}>
          <h1>Si è verificato un errore</h1>
          <p>Ricarica la pagina per continuare.</p>
          <button type="button" onClick={() => window.location.reload()}>
            Ricarica
          </button>
        </main>
      );
    }

    return this.props.children;
  }
}

